export default "__VITE_ASSET__CEYG6kDB__"